<script>
    import ItemNameCell from "./ItemNameCell.svelte";
    import dbData from "../../Stores/utilityDBStore.js";
    import { itemUrlForKey } from "../../scripts/wpn2Model.js";

    const apiUrl = process.env.VITE_API_URL;
    export let filteredData;

    let sortOptions = {
        name: { col: "name", ascending: true },
        summary: { col: "summary", ascending: true },
    };

    $: sort = (key) => {
        let sortBy = sortOptions[key];
        sortOptions[column].ascending = !sortBy.ascending;
    };
</script>

<div class="table-container">
    <table class="items-table">
        <thead>
            <tr>
                <th scope="col" class="non-sortable" />
                <th scope="col" on:click={sort("name")}>Name</th>
                <th scope="col" on:click={sort("summary")}>Summary</th>
                <th scope="col" class="non-sortable" />
                <th scope="col" class="non-sortable" />
            </tr>
        </thead>
        <tbody>
            {#each filteredData as item}
                <tr>
                    <td><ItemNameCell {item} showName={false}/></td>
                    <td id="tutorial-name-col">
                        {item.name ?? ""}
                    </td>
                    <td id="summary-col">
                        {item.summary ?? ""}
                    </td>
                    <td id="pdf-col">
                        {#if itemUrlForKey("pdfName", item, $dbData.wpn_id, apiUrl) != undefined}
                            <a
                                href={"wpn64.com/tutorials/" +
                                    itemUrlForKey("pdfName", item, $dbData.wpn_id, apiUrl)}
                                type="application/pdf"
                                target="_blank"
                            >
                                <img
                                    src="images/iconPDFGuide@2x.png"
                                    alt="PDF icon"
                                    width="32"
                                    height="32"
                                />
                            </a>
                        {/if}
                    </td>
                    <td id="video-col">
                        {#if itemUrlForKey("videoURL", item, $dbData.wpn_id, apiUrl) != undefined}
                            <a
                                href={itemUrlForKey("videoURL", item, $dbData.wpn_id, apiUrl)}
                                type="video/vnd.youtube.yt"
                                target="_blank"
                            >
                                <img
                                    src="images/iconPlayVideo@2x.png"
                                    alt="Play video icon"
                                    width="32"
                                    height="32"
                                />
                            </a>
                        {/if}
                    </td>
                </tr>
            {/each}
        </tbody>
    </table>
</div>

<style>
    .table-container {
        height: 72vh;
        overflow: scroll;
    }
    .items-table {
        text-align: left;
        -webkit-border-vertical-spacing: 0;
        border-collapse: collapse;
        table-layout: auto;
        padding: 8px;
        width: 100%;
        overflow: scroll;
    }
    #tutorial-name-col {
        padding: 6px 8px;
        width: 20vw;
    }
    #summary-col {
        padding: 6px 8px;
    }
    #pdf-col {
        padding: 4px;
    }
    #video-col {
        padding: 4px 8px 4px 4px;
    }
</style>
